var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetProjectElement',{attrs:{"title":_vm.pointOfInterest.title,"subtitle":_vm.pointOfInterest.shortText,"text-alignment":_vm.textAlignment,"enter-to":_vm.pointOfInterestRouteObject,"exterior-tour360-to":_vm.exteriorTour360RouteObject}})
}
var staticRenderFns = []

export { render, staticRenderFns }